// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cube-picker-wheel-wrapper div:nth-child(2){flex:2;-webkit-box-flex:2;-webkit-flex:2}", ""]);
// Exports
module.exports = exports;
